// Constrói o modelo decorado de um card a partir de um lead real.
// Mapeamento conforme docs/crm-kanban-redesign.md.
import {
  TAGS,
  CH,
  PRIO,
  SLA,
  fmtBRL,
  fmtTimer,
  slaState,
  attendantColor,
  initials,
} from "./tokens";

// stage: { id, name, color, kind } resolvido; slaLimite: número de minutos.
export const decorateLead = (lead, stage, slaLimite) => {
  // Timer/SLA congelam quando o estágio não é 'open'.
  const isOpen = stage ? stage.kind === "open" : true;
  // Espera só conta quando o CLIENTE mandou algo e ainda não foi respondido:
  // se a última mensagem foi do atendente (lastFromMe) ou não há inbound pendente
  // (awaitingSince nulo), o timer fica neutro ("em dia"). Fallback p/ leads sem
  // ticket/mensagens (dados antigos): usa lastContactAt.
  const awaitingSince =
    lead.awaitingSince !== undefined ? lead.awaitingSince : lead.lastContactAt;
  const isAwaiting = isOpen && !lead.lastFromMe && !!awaitingSince;
  const mins = isAwaiting
    ? Math.max(0, (Date.now() - new Date(awaitingSince).getTime()) / 60000)
    : 0;

  const sla = isAwaiting ? slaState(mins, slaLimite, true) : "ok";
  const [slaBg, slaText, slaBar] = SLA[sla];

  const ch = CH[lead.channel] || ["", "#94A3B8"];
  const tg = TAGS[lead.tag] || ["#52606D", "#E4E7EB"];
  const pr = PRIO[lead.priority] || PRIO.baixa;

  const agName = lead.user?.name || "";
  const value = Number(lead.value) || 0;
  const limit = Number(slaLimite) || 60;

  return {
    id: lead.id,
    raw: lead,
    name: lead.name || "",
    phone: lead.number || "",
    msg: lead.notes || "",
    stageColor: stage?.color || "#64748B",
    stageKind: stage?.kind || "open",
    isOpen,

    mins,
    isAwaiting,
    timeFmt: isAwaiting ? fmtTimer(mins) : "em dia",
    slaState: sla,
    slaBg,
    slaText,
    slaBar,
    slaPct: Math.min(100, Math.round((mins / (limit * 2)) * 100)) + "%",

    value,
    valueFmt: fmtBRL(value),

    tag: lead.tag || "",
    tagColor: tg[0],
    tagBg: tg[1],

    channel: lead.channel || "",
    chLabel: ch[0],
    chColor: ch[1],

    priority: lead.priority || "",
    prioLabel: pr[0],
    prioColor: pr[1],
    prioBg: pr[2],

    agName,
    agInitials: initials(agName),
    agColor: attendantColor(agName),
    hasAttendant: !!agName,
  };
};
